import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 80vh;
  background-color: #f9fafb;
  text-align: center;
`;

const ErrorCode = styled.h1`
  font-size: 6rem;
  margin-bottom: 1rem;
  color: #0b223f;

  @media (max-width: 768px) {
    font-size: 4rem;
    margin: 0.5rem;
  }
`;

const ErrorMessage = styled.h2`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #0b223f;

  @media (max-width: 768px) {
    font-size: 2rem;
    margin: 0 1rem;
  }
`;

const ErrorDescription = styled.p`
  font-size: 1rem;
  margin-bottom: 2rem;
  color: #6b7280;

  @media (max-width: 768px) {
    font-size: 0.7rem;
    margin-bottom: 1rem;
  }
`;

const Button = styled.button`
  color: black;
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1rem 1.5rem;
  gap: 0.5rem;
  border: 1px solid #0b223f;
  border-radius: 5px;
  font-size: 1rem;

  &:hover {
    background: linear-gradient(90deg, #0b223f 0%, #1d59a5 100%);
    color: white;
  }

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const PageNotFound: React.FC = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  return (
    <Container>
      <ErrorCode>404</ErrorCode>
      <ErrorMessage>Page not found</ErrorMessage>
      <ErrorDescription>Oops! The page you are looking for does not exist.</ErrorDescription>
      <Button onClick={goHome}>Back to home page</Button>
    </Container>
  );
};
